import { useMutation, useQueryClient } from "@tanstack/react-query";
import { callApi } from "../../utils/ApiCallPostOnly";

export const useDeletePendingReturn = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data) =>
      callApi({
        path: "receivedreturnordercard",
        command: "delete",
        data: JSON.stringify(data),
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["receivedreturnorderlist"] });
    },
  });
};
